<template>
  <div>
    <sale-order-list v-show="activeKey===1" ref="list" :orderStatus="orderStatus" :owners="owners" @add="add" @getDetail="getDetail"/>
    <sale-order-detail v-show="activeKey===2" ref="detail" :logicalStores="logicalStores" :owners="owners" :pickupModes="pickupModes" @back="back"/>
  </div>
</template>
<script>
import { findAll } from '@/api/Api'
import SaleOrderList from '@/views/outbound/sale_order_make/SaleOrderList.vue'
import SaleOrderDetail from '@/views/outbound/sale_order_make/SaleOrderDetail.vue'
import { getDictionaries, getEnums, getOptions } from '@/utils/util'

export default {
  name: 'SaleOrderMake',
  components: { SaleOrderList, SaleOrderDetail },
  data() {
    return {
      activeKey: 1,
      orderStatus: [],
      owners: [],
      pickupModes: [],
      logicalStores: []
    }
  },
  created() {
    findAll('partyFactory', { available: true, 'type.ordinal': 1 }).then(res => {
      if (res.success) {
        this.owners = getOptions(res.result)
      }
      return getDictionaries('PICKUP_MODE')
    }).then(result => {
      this.pickupModes = result
      return getDictionaries('LOGICAL_STORE')
    }).then(result => {
      this.logicalStores = result
      return getEnums('OrderStatus')
    }).then(result => {
      this.orderStatus = result
    })
  },
  methods: {
    back() {
      this.activeKey = 1
      this.$refs.list.refresh()
    },
    getDetail(row) {
      this.activeKey = 2
      this.$refs.detail.fetch(row)
    },
    add() {
      this.activeKey = 2
      this.$refs.detail.reset()
    }
  }
}
</script>